import { render, staticRenderFns } from "./inspectionPersonEdit.vue?vue&type=template&id=8bdbe2a0&scoped=true&"
import script from "./inspectionPersonEdit.vue?vue&type=script&lang=js&"
export * from "./inspectionPersonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdbe2a0",
  null
  
)

export default component.exports